/**
 * 全画面（シアター）モード。
 *
 * 画面いっぱいに映像だけを出す状態。ブラウザの全画面も併せて要求するが、
 * 全画面にできない環境（iOS Safari など）でもページ内のレイアウトだけは切り替える。
 */

import { createSignal, onCleanup, onMount } from 'solid-js'

export type TheaterStore = {
  active: () => boolean
  enter: () => void
  exit: () => void
  toggle: () => void
}

export const createTheaterStore = (): TheaterStore => {
  const [active, setActive] = createSignal(false)

  const enter = (): void => {
    setActive(true)
    // 全画面にできなくてもシアター表示は続ける
    void document.documentElement.requestFullscreen?.().catch(() => {})
  }

  const exit = (): void => {
    setActive(false)
    if (document.fullscreenElement) void document.exitFullscreen().catch(() => {})
  }

  const toggle = (): void => {
    if (active()) exit()
    else enter()
  }

  onMount(() => {
    // Esc やブラウザ側の操作で全画面を抜けたら、シアターも終える
    const handleChange = (): void => {
      if (!document.fullscreenElement) setActive(false)
    }
    document.addEventListener('fullscreenchange', handleChange)
    onCleanup(() => document.removeEventListener('fullscreenchange', handleChange))
  })

  return { active, enter, exit, toggle }
}
